import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-partnership-report',
  templateUrl: './partnership-report.component.html',
  styleUrls: ['./partnership-report.component.css']
})
export class PartnershipReportComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];
  p: number = 1;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any = [];
  recordsperpage: number = 25;
  datass: any = [];
  sortOrder = 0;
  AutoProductOffer: any = [];
  overall_total_offer: number = 0;
  detailedReport: any = [];
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.model['mobile'] = '';
    this.model['code'] = '';
    this.model['partnership_bill_no'] = '';
    this.model['name'] = '';
    this.getPartnershipReport('');
    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
  }

  onDateChanged(event: IMyDateModel, id): void { }

  getPartnershipReport(data) {
    this.loginservice.getPartnershipReport(data, this.currentUser)
      .subscribe(
        data => {
          if (data['detailedReport'].length > 0) {
            this.detailedReport = data['detailedReport'];
          } else {
            this.detailedReport = [];
          }
          if (data['data'].length > 0) {
            this.dataresult = data['data'];
            this.showLoader = false;
            let tableArr: Element[] = data['data'];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataresult.length = 0;
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            let tableArr: Element[] = [];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        },
        error => {
          alert('Network Error getPartnershipReport API');
          this.showLoader = false;
          alert('Offer Report Is Still Pending')
        });
  }


  search() {
    if (this.model['partnership_bill_no'] == '' && this.model['name'] == '' && this.model['code'] == '' && this.model['mobile'] == '') {
      return false;
    }
    let data = {
      mobile: this.model['mobile'],
      code: this.model['code'],
      partnership_bill_no: this.model['partnership_bill_no'],
      name: this.model['name'],
    };
    this.getPartnershipReport(data)
  }

  reset() {
    this.model['mobile'] = '';
    this.model['code'] = '';
    this.model['partnership_bill_no'] = '';
    this.model['name'] = '';
    this.ngOnInit();
  }

  changeRecordPerPage(value) {
    this.recordsperpage = value;
  }

  tableToExcel(table, excelName) {
    let list: any = [];
    var exports1 = [];
    this.datass = this.dataresult;
    exports1 = this.dataresult;
    let sno = 0;
    exports1.forEach(element => {
      sno = sno + 1;
      if (!element.partnership_commission || element.partnership_commission === '') {
        element.partnership_commission = 0;
      }
      if (!element.paid_commission || element.paid_commission === '') {
        element.paid_commission = 0;
      }
      if (!element.balance_commission || element.balance_commission === '') {
        element.balance_commission = 0;
      }
      list.push({ '#': sno, 'Partner Name': element.name, 'Contact Person': element.person_name, 'Mobile': element.mobile, 'Code': element.code, 'Coupon Name': element.coupon, 'Percentage': element.percentage + '%', 'Voucher Quantity': element.quantity, 'Voucher Issued Quantity': element.issued_count, 'Voucher Balance Quantity': element.balance_quantity, 'Earned Commission': element.partnership_commission, 'Commission Paid To Partner': element.paid_commission, 'Balance Commission': element.balance_commission });
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(list);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelName + '.xls', { bookType: 'xls', type: 'buffer' });
  }



  tableToExcelDetailed(table, excelName) {
    let list: any = [];
    var detailedReport = [];
    detailedReport = this.detailedReport;
    let sno = 0;
    detailedReport.forEach(element => {
      sno = sno + 1;
      if (!element.partnership_commission || element.partnership_commission === '') {
        element.partnership_commission = 0;
      }
      if (!element.paid_commission || element.paid_commission === '') {
        element.paid_commission = 0;
      }
      if (!element.balance_commission || element.balance_commission === '') {
        element.balance_commission = 0;
      }
      if (element.paid_status == '1') {
        element.paid_status = 'Paid';
      } else {
        element.paid_status = 'Not Paid';
      }
      list.push({
        '#': sno,
        'Partner Name': element.name,
        'Contact Person': element.person_name,
        'Mobile': element.mobile,
        'Code': element.code,
        'Coupon Name': element.coupon,
        'Percentage': element.percentage + '%',
        'Voucher Quantity': element.quantity,
        'Voucher Issued Quantity': element.issued_count,
        'Voucher Balance Quantity': element.balance_quantity,
        'Earned Commission': element.partnership_commission,
        'Commission Paid To Partner': element.paid_commission,
        'Balance Commission': element.balance_commission,
        'Customer Name': element.f_name,
        'Customer Phone': element.phone,
        'Bill No': element.partnership_bill_no,
        'Total Invoice Amount': element.total_invoice_amount,
        'Discount Amount': element.discount_value,
        'Invoice Total': element.invoice_amount,
        'Partnership Percentage': element.partnership_percentage,
        'Commission': element.partnership_commission,
        'Payment Status': element.paid_status,
      });
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(list);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelName + '.xls', { bookType: 'xls', type: 'buffer' });
  }

  sortable(sort) {
    let order = ""
    if (this.sortOrder == 0) {
      order = "DESC";
      this.sortOrder = 1;
    } else {
      order = "ASC";
      this.sortOrder = 0;
    }
    let data = {
      mobile: this.model['mobile'],
      code: this.model['code'],
      partnership_bill_no: this.model['partnership_bill_no'],
      name: this.model['name'],
      sort: sort,
      sortOrder: order
    };
    this.getPartnershipReport(data)
  }

  printBill(bill_no, customer_id) {
    this.loginservice.printBill(bill_no, customer_id, this.currentUser)
      .subscribe(
        data => {
          if (data) {
            this.router.navigate(['print-preview'], {
              queryParams: {
                tot_amt: JSON.stringify(data['tot_amt']),
                invoiceTotal: JSON.stringify(data['invoiceTotal']),
                model: JSON.stringify(data['model']),
                multiple_offer: JSON.stringify(data['multiple_offer']),
                chekoutArray: JSON.stringify(data['chekoutArray']),
                product_multiple_offer: JSON.stringify(data['product_multiple_offer']),
                productsTobuy: JSON.stringify(data['productsTobuy']),
                discount: JSON.stringify(data['discount']),
                bill_no: JSON.stringify(data['bill_no']),
                add_charge: JSON.stringify(data['add_charge']),
                billed_on: JSON.stringify(data['billed_on']),
                from: JSON.stringify('partnerReport'),
              }
            });
          }
        }, error => { alert('Network Error printBill API'); });
  }

  change_status(list) {
    this.loginservice.changestatus(list, this.currentUser)
      .subscribe(
        data => {
          list.paid_status = '1';
        }, error => { alert('Network Error changestatus API'); });
  }

}



// WEBPACK FOOTER //
// ./src/app/partnership-report/partnership-report.component.ts